import React from "react";
import { Form } from "antd";
import Input from "./BaseInput";

interface ProductNameFieldProps {}

const ProductNameField: React.FC<ProductNameFieldProps> = function (props) {
    return (
        <Form.Item label={<span className="search-field-label">商品名称</span>} name="orderItemTitle">
            <Input />
        </Form.Item>
    );
};

export default React.memo(ProductNameField);
